<template>
  <div class="settings">
    <Breadcrumbs :items="breadcrumbs"/>

    <rp-password-form
      @submit="submit"
      v-model="form"/>

    <rp-overlay :active="active">
      <rp-alert
        icon="done"
        :message="successMessage"
        :onClick="successFunction">
      </rp-alert>
    </rp-overlay>
  </div>
</template>

<script>
import {updatePassword} from 'raypro_ui/src/api/users'
import {mapGetters} from 'vuex'

import PasswordForm from 'raypro_ui/src/components/ui/forms/ResetPassword'
import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Alert from 'raypro_ui/src/components/ui/Alert'

import page from '@/mixins/page'
import Breadcrumbs from '@/components/Breadcrumbs'

export default {
  components: {
    'rp-password-form': PasswordForm,
    'rp-overlay': Overlay,
    'rp-alert': Alert,
    Breadcrumbs
  },

  data() {
    return {
      form: {
        old_password: '',
        new_password: '',
        confirm_new_password: ''
      },
      active: false,
      successMessage: 'Your password has been changed. You will now be redirected to the login page.',
      breadcrumbs: [
        {label: 'Reset Password'}
      ],
      title: 'Reset Password'
    }
  },

  mixins: [page],

  computed: {
    ...mapGetters([
      'authUser'
    ]),

    payloadPassword() {
      const id = this.authUser.id

      return {
        id,
        data: {
          old_password: this.form.old_password,
          new_password: this.form.new_password,
          user_id: id
        }
      }
    }
  },
  methods: {
    successFunction() {
      this.$router.push({name: 'Login'})
    },

    submit() {
      updatePassword(this.payloadPassword).then(() => {
        this.active = true
      })
    }
  }
}
</script>

<style lang="sass" scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/ResetPassword.vue